import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";

export function useIsProjectSetup() {
  const { project, isLoading, projectId } = useCurrentProjectContext();

  const hasStyleLibrary = Boolean(project?.styleLibrary);

  const shouldShowStyleLibraryModal =
    !isLoading &&
    Boolean(projectId) &&
    !hasStyleLibrary &&
    project?.hostingType === "replo";

  return {
    shouldShowStyleLibraryModal,
  };
}
